/**
 * Shopping Cart
 */
/**
 * Disclaimer Checkbox and Button disabled
 */
function cartSectionsCheckbox(e) {
    e.preventDefault();

    // console.log(purchaseModalOpenOnce);

    if (!$(this).hasClass('checked')) {
        $(this).addClass('checked');
        $('.cart-sections .subscribe-box__checkbox').attr('data-checkbox', true);

        if (!$.cookie('cartCTAClicked') && purchaseModalOpenOnce == true) {
            $('#cartCTA').attr('data-toggle', 'false');
        }

    } else {
        $(this).removeClass('checked');
        $('.cart-sections .subscribe-box__checkbox').attr('data-checkbox', false);

        if (!$.cookie('cartCTAClicked') && purchaseModalOpenOnce == true) {
            $('#cartCTA').attr('data-toggle', 'modal');
        }
    }

    $('.cart-sections .cart__product.active').trigger("click");
}

/**
 * Data Attributes list
 */
// Set Prices
function setLinks() {
    let thisProduct = $(this),
        link,
        subscribeAttr = $('.cart-sections .subscribe-box__checkbox').attr('data-checkbox'),

        //- Regular modal popup
        modalCtaRegular = $('#regularButton'),
        modalCtaSubscribe = $('#subscribeButton'),
        linkRegular = 'data-link',
        linkSubscribe = 'data-subscribe-link';

    if (subscribeAttr == 'true') {
        link = 'data-subscribe-link';
    } else {
        link = 'data-link';
    }

    let param = $('.cart-sections .cta').attr('data-param');
    $('.cart-sections .cta').attr('href', thisProduct.attr(link) + param);

    //- handle Regular Modal button links
    modalCtaRegular.attr('href', thisProduct.attr(linkRegular) + param);
    modalCtaSubscribe.attr('href', thisProduct.attr(linkSubscribe) + param);
}

// Calculate Instant and Member Savings based on retailVal and price
function calcSavings(subscribeAttr, thisProduct, retailVal) {
    let price = thisProduct.attr('data-price'),
        priceSubs = thisProduct.attr('data-subscribe-price');

    //- Calculate Savings and Member Savings based on data-retail, data-price and data-subscribe-price values
    let saving = Number(retailVal - price).toFixed(2),
        savingSubs = Number(retailVal - priceSubs).toFixed(2),
        memberSaving = Number(savingSubs - saving).toFixed(2);

    if (subscribeAttr == 'true') {
        $('.cart-sections .saving__value').html('$' + savingSubs);
        $('.cart-sections .member__value').html('$' + memberSaving);

    } else {
        $('.cart-sections .saving__value').html('$' + saving);
    }
}

// Set Active Product
function activeProductSections() {
    let thisProduct = $(this),
        amount = thisProduct.attr('data-units');

    let subscribeAttr = $('.cart-sections .subscribe-box__checkbox').attr('data-checkbox');

    let freeUnits;

    //- handle Modal popup
    let priceModalRegular = $('#purchaseModal').find('.amount--regular'),
        priceModalContinuity = $('#purchaseModal').find('.amount--continuity'),
        priceSubscribe = 'data-subscribe-price';

    const retail = thisProduct.attr('data-retail');

    calcSavings(subscribeAttr, thisProduct, retail);

    let price, shipping;

    $('#orderNow').removeClass(function (index, className) {
        return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
    }).addClass('cart--unit' + amount);

    if (subscribeAttr == 'true') {
        price = 'data-subscribe-price';
        shipping = 'data-subscribe-shipping';
        freeUnits = 'free-units-subscribe';

        $('.cart-sections .summary').addClass('summary--subscribe');

    } else {
        price = 'data-price';
        shipping = 'data-shipping';
        freeUnits = 'free-units';

        $('.cart-sections .summary').removeClass('summary--subscribe');
    }

    let pricePerUnit = parseFloat(thisProduct.attr(price) / amount).toFixed(2);

    $('.cart-sections .cart__product').removeClass('active');
    thisProduct.addClass('active');

    $('.cart-sections .price-per-unit__value').html('$' + pricePerUnit);
    $('.cart-sections .price__value').html('$' + thisProduct.attr(price));
    $('.cart-sections .retail__value').html('$' + retail);
    $('.cart-sections .shipping__value').html(thisProduct.attr(shipping));

    // $('.cart-sections .freeQuantity__value').html($('.cart-sections .cart__product').attr(freeUnits));

    priceModalRegular.find('.amount__value').html('$' + thisProduct.attr(price));
    priceModalContinuity.find('.amount__value').html('$' + thisProduct.attr(priceSubscribe));

    if ($('.purchase-badges').length) {
        purchaseBadges($('.cart__body'), thisProduct, retail, thisProduct.attr(price));
    }

    $('.cart-sections .cart__product').each(function (index) {
        // console.log($(this));
        // console.log($(this).data(freeUnits));

        if ($(this).attr(shipping) == '') {
            $(this).find('.cart__product-shipping').css('visibility', 'hidden');

        } else {
            $(this).find('.cart__product-shipping').html($(this).attr(shipping) + ' Shipping').css('visibility', 'visible');
        }

        $(this).find('.freeQuantity__value').html($(this).data(freeUnits));
    });
};

$('.cart-sections .cart__product').on('click', setLinks);
$('.cart-sections .cart__product').on('click', activeProductSections);
$('.cart-sections .cart__product.active').trigger("click");
$('.cart-sections .subscribe-box__checked').on('click', cartSectionsCheckbox);
